'use strict';

var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Annotate = require('./annotate');
var Common = require('./common');
var Template = require('./template');
var internals = {};
exports.Report = /*#__PURE__*/function () {
  function _class(code, value, local, flags, messages, state, prefs) {
    _classCallCheck(this, _class);
    this.code = code;
    this.flags = flags;
    this.messages = messages;
    this.path = state.path;
    this.prefs = prefs;
    this.state = state;
    this.value = value;
    this.message = null;
    this.template = null;
    this.local = local || {};
    this.local.label = exports.label(this.flags, this.state, this.prefs, this.messages);
    if (this.value !== undefined && !this.local.hasOwnProperty('value')) {
      this.local.value = this.value;
    }
    if (this.path.length) {
      var key = this.path[this.path.length - 1];
      if (typeof key !== 'object') {
        this.local.key = key;
      }
    }
  }
  _createClass(_class, [{
    key: "_setTemplate",
    value: function _setTemplate(template) {
      this.template = template;
      if (!this.flags.label && this.path.length === 0) {
        var localized = this._template(this.template, 'root');
        if (localized) {
          this.local.label = localized;
        }
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this.message) {
        return this.message;
      }
      var code = this.code;
      if (!this.prefs.errors.render) {
        return this.code;
      }
      var template = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
      if (template === undefined) {
        return "Error code \"".concat(code, "\" is not defined, your custom type is missing the correct messages definition");
      }

      // Render and cache result

      this.message = template.render(this.value, this.state, this.prefs, this.local, {
        errors: this.prefs.errors,
        messages: [this.prefs.messages, this.messages]
      });
      if (!this.prefs.errors.label) {
        this.message = this.message.replace(/^"" /, '').trim();
      }
      return this.message;
    }
  }, {
    key: "_template",
    value: function _template(messages, code) {
      return exports.template(this.value, messages, code || this.code, this.state, this.prefs);
    }
  }]);
  return _class;
}();
exports.path = function (path) {
  var label = '';
  var _iterator = _createForOfIteratorHelper(path),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var segment = _step.value;
      if (typeof segment === 'object') {
        // Exclude array single path segment
        continue;
      }
      if (typeof segment === 'string') {
        if (label) {
          label += '.';
        }
        label += segment;
      } else {
        label += "[".concat(segment, "]");
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return label;
};
exports.template = function (value, messages, code, state, prefs) {
  if (!messages) {
    return;
  }
  if (Template.isTemplate(messages)) {
    return code !== 'root' ? messages : null;
  }
  var lang = prefs.errors.language;
  if (Common.isResolvable(lang)) {
    lang = lang.resolve(value, state, prefs);
  }
  if (lang && messages[lang] && messages[lang][code] !== undefined) {
    return messages[lang][code];
  }
  return messages[code];
};
exports.label = function (flags, state, prefs, messages) {
  if (flags.label) {
    return flags.label;
  }
  if (!prefs.errors.label) {
    return '';
  }
  var path = state.path;
  if (prefs.errors.label === 'key' && state.path.length > 1) {
    path = state.path.slice(-1);
  }
  var normalized = exports.path(path);
  if (normalized) {
    return normalized;
  }
  return exports.template(null, prefs.messages, 'root', state, prefs) || messages && exports.template(null, messages, 'root', state, prefs) || 'value';
};
exports.process = function (errors, original, prefs) {
  if (!errors) {
    return null;
  }
  var _exports$details = exports.details(errors),
    override = _exports$details.override,
    message = _exports$details.message,
    details = _exports$details.details;
  if (override) {
    return override;
  }
  if (prefs.errors.stack) {
    return new exports.ValidationError(message, details, original);
  }
  var limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 0;
  var validationError = new exports.ValidationError(message, details, original);
  Error.stackTraceLimit = limit;
  return validationError;
};
exports.details = function (errors) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var messages = [];
  var details = [];
  var _iterator2 = _createForOfIteratorHelper(errors),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      // Override

      if (item instanceof Error) {
        if (options.override !== false) {
          return {
            override: item
          };
        }
        var _message = item.toString();
        messages.push(_message);
        details.push({
          message: _message,
          type: 'override',
          context: {
            error: item
          }
        });
        continue;
      }

      // Report

      var message = item.toString();
      messages.push(message);
      details.push({
        message: message,
        path: item.path.filter(function (v) {
          return typeof v !== 'object';
        }),
        type: item.code,
        context: item.local
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (messages.length > 1) {
    messages = _toConsumableArray(new Set(messages));
  }
  return {
    message: messages.join('. '),
    details: details
  };
};
exports.ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(_class2, _Error);
  function _class2(message, details, original) {
    var _this;
    _classCallCheck(this, _class2);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this, message));
    _this._original = original;
    _this.details = details;
    return _this;
  }
  _createClass(_class2, null, [{
    key: "isError",
    value: function isError(err) {
      return err instanceof exports.ValidationError;
    }
  }]);
  return _class2;
}(_wrapNativeSuper(Error));
exports.ValidationError.prototype.isJoi = true;
exports.ValidationError.prototype.name = 'ValidationError';
exports.ValidationError.prototype.annotate = Annotate.error;